import React from 'react';
import { Home, HomeProps } from 'modules/home/desktop';
import { getServerSidePropsHome } from 'modules/home/shared';

const HomePage: React.FunctionComponent<HomeProps> = (props: HomeProps) => {
  return <Home {...props} />;
};

export const getServerSideProps = getServerSidePropsHome;

export default HomePage;
